export default "__VITE_ASSET__Ba_Z6UUd__";